import { StarRating } from "components/UI/atoms";
import { getMessageByCount } from "utils/format";
import { rateBrand as rateBrandRequest } from "./requests";
import { useState } from "react";

export const useBrandRating = ({ id, rating }) => {
  const { value, count } = rating;
  const [hasVoted, setHasVoted] = useState(false);
  const [stars, setStars] = useState(value);

  const makeStar = (filled, onClick) => {
    if (filled === 0.5) {
      return (
        <button onClick={onClick}>
          <StarRating isHalfStar isYellowStar />
        </button>
      );
    } else if (filled > 0) {
      return (
        <button onClick={onClick}>
          <StarRating />
        </button>
      );
    }

    return (
      <button onClick={onClick}>
        <StarRating isYellowStar={false} />
      </button>
    );
  };

  const makeStars = (onClick) => {
    let starsCount = stars;
    const starsArray = new Array(5).fill("");

    return starsArray.map((_, index) => {
      const handleStarClick = () => onClick(index);
      const star = <li key={index}>{makeStar(starsCount, handleStarClick)}</li>;
      starsCount--;
      return star;
    });
  };

  const rateBrand = async (value) => {
    const userRating = value + 1;
    setHasVoted(true);

    try {
      const response = await rateBrandRequest({ id, rating: userRating });
      if (response?.rating) setStars(userRating);
    } catch (error) {}
  };

  const ratingMessage = getMessageByCount({
    messages: {
      oneItem: `${count} Rating`,
      without: "No ratings",
      moreThanOne: `${count} Ratings`
    },
    count
  });

  return {
    hasVoted,
    ratingMessage,
    makeStars,
    rateBrand
  };
};
